module.exports = __webpack_public_path__ + "static/media/entertainment1.38c2f27d.jpg";